import BaseLabel from './BaseLabel.vue';
export default BaseLabel;
